import { ThermometerSun, VolumeX, Leaf, Smartphone } from "lucide-react";
import FadeIn from "@/components/FadeIn";

const BENEFITS = [
  {
    icon: ThermometerSun,
    title: "Réversible, toute l'année",
    text: "Fraîcheur l'été, chauffage très économique en mi-saison et en hiver : 1 kWh consommé restitue 3 à 4 kWh de chaleur.",
    testid: "clim-benefit-reversible",
  },
  {
    icon: VolumeX,
    title: "Silence Daikin",
    text: "Unités intérieures dès 19 dB(A) selon modèle : plus discret qu'un chuchotement, idéal pour les chambres.",
    testid: "clim-benefit-silence",
  },
  {
    icon: Leaf,
    title: "Consommation maîtrisée",
    text: "Technologie Inverter et classes énergétiques jusqu'à A+++ : la puissance s'ajuste en continu, sans à-coups.",
    testid: "clim-benefit-conso",
  },
  {
    icon: Smartphone,
    title: "Pilotage smartphone",
    text: "Application Daikin Onecta : programmez, ajustez et suivez votre consommation à distance, pièce par pièce.",
    testid: "clim-benefit-app",
  },
];

export default function ClimBenefits() {
  return (
    <section
      id="avantages"
      data-testid="clim-section-avantages"
      className="bg-white py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.15fr] lg:gap-20">
        <FadeIn className="relative">
          <div className="overflow-hidden rounded-[2rem] shadow-card">
            <img
              src="/clim-famille.webp"
              alt="Famille profitant de la fraîcheur sous une climatisation Daikin"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 right-4 rounded-2xl border border-glacier-border bg-white px-5 py-4 shadow-card sm:right-8">
            <p className="font-display text-3xl font-extrabold text-ice">×3</p>
            <p className="text-xs text-slate-500">
              plus efficace qu'un radiateur électrique*
            </p>
          </div>
        </FadeIn>

        <div>
          <FadeIn>
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-ice sm:text-xs">
              Pourquoi Daikin avec Ener Solutions
            </p>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-5xl">
              Le confort qui se fait oublier.
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
              Une climatisation bien dimensionnée et bien posée, c'est une pièce
              à la bonne température en quelques minutes, sans bruit et sans
              mauvaise surprise sur la facture.
            </p>
          </FadeIn>

          <div className="mt-10 grid gap-4 sm:grid-cols-2">
            {BENEFITS.map((b, i) => (
              <FadeIn key={b.title} delay={i * 0.08} className="h-full">
                <div
                  data-testid={b.testid}
                  className="group flex h-full flex-col rounded-2xl border border-glacier-border bg-glacier p-6 transition-all duration-300 hover:-translate-y-1 hover:border-ice/40 hover:bg-white hover:shadow-card"
                >
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-white text-ice shadow-sm transition-colors group-hover:bg-ice group-hover:text-white">
                    <b.icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-bold text-ink">{b.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{b.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
          <p className="mt-6 text-[11px] text-slate-400">
            *Rendement indicatif d'une pompe à chaleur air/air Inverter (COP 3
            à 4) comparé à un convecteur électrique.
          </p>
        </div>
      </div>
    </section>
  );
}
